module.exports = __webpack_public_path__ + "img/factsheet_parking.2c28e2b4.png";